import { routesStructure } from './routesStructure';
import { pathsAllowedToSpecificContract } from './pathsAllowedToSpecificContract';

function checkAllowedRoute({ path, dataGlobal }) {
    const { dataActiveContract, contractsList, dataLogin } = dataGlobal;

    const permissions = dataLogin?.permissoesFlat;

    const isAdmin = permissions[8];

    if (dataActiveContract.isGPA) return false;

    if (path?.includes('aposentados_demitidos') && !dataActiveContract.exigeTermoContributario) return false;

    if (path?.includes('centro_custo') && !dataActiveContract.isPj) return false;

    if (path?.includes('reativar_beneficiario') && !dataActiveContract.isAdesao) return false;

    if (path?.includes('transferencia_beneficiario') && contractsList.length <= 1) return false;

    if (path?.includes('gerenciar_usuarios') && !isAdmin) return false;

    if (path?.includes('selecionar_lotacao') && (dataActiveContract.isPme || dataActiveContract.isAdesao)) return false;

    const [, primaryPath] = path?.split('/') || [];

    const dataActualPath = routesStructure[primaryPath];

    const isAllowed = permissions[dataActualPath?.codigo] || false;

    // Caso seja contrato especifico, so permite as rotas da lista especifica
    if (dataActiveContract.isSpecificContract) {
        const lastPath = path.split('/').at(-1);

        return (pathsAllowedToSpecificContract.includes(`/${lastPath}`) && (isAllowed || isAdmin)) || path === '/';
    }

    return isAllowed || path === '/' || isAdmin;
}

export { checkAllowedRoute };
